import {Box, styled, Typography} from '@mui/material';

const StyledFooterContainer = styled(Box)`
	margin: auto 0px 72px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

const StyledBox = styled(Box)`
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	border-radius: 8px;
`;

const StyledTypography = styled(Typography)`
	& strong {
		font-weight: 700;
	}
`;

export {StyledFooterContainer, StyledBox, StyledTypography};
